(function () {
    'use strict';

    a3_cabin_reports.factory('FaceMasksFactory', FaceMasksFactory);

    /**
     * @memberof CabinReports
     * @ngdoc factory
     * @name FaceMasksFactory
     * @description 
     * Get, Set and Submit Face Mask Info per flight.
     * @ngInject
     */
    function FaceMasksFactory(FlightFactory, $http, apiUrl) {
        var submitResponseObj = { success: false, message: '' }

        var service = {
            submitFaceMaskReport : submitFaceMaskReport
        };

        /**
         * Sends the Face Masks report
         * @memberof FaceMasksFactory
         * @param {object} flightMasks The Flight Face Masks Report
         * @returns {promise} submitResponseObj
         */
        function submitFaceMaskReport(flightMasks) {
            var objectToAdd = flightMasks;

            return $http.post(apiUrl + '/FaceMasks/', flightMasks, { 'Content-Type': 'application/json' })
                .then(res => saveReportSuccessCallBack(res, objectToAdd))
                .catch(res => saveReportFailedCallBack(res));
        }

         /**
          * The callback function upon successful submit
          * @param {object} res 
          * @param {object} objectToAdd 
          * @returns {object} submitResponseObj
          */
        function saveReportSuccessCallBack(res, objectToAdd) {
            submitResponseObj.success = res.data.success;
            if (res.data.success) {
                //Attach face mask info to flight
                var flight = FlightFactory.getFlightFromStorage(objectToAdd.FlightId);
                flight.FaceMasks = objectToAdd;
                FlightFactory.updateFlight(flight);

                submitResponseObj.message = "Success! Your input has been sent";
            }
            else {
                submitResponseObj.message = res.data.errorMessage
            }
            return submitResponseObj;
        }

        /**
        * The callback function upon failure on submit
        * @returns {object} submitResponseObj
        */
        function saveReportFailedCallBack(res) {
            submitResponseObj.success = false;
            submitResponseObj.message = "Oops! Something went wrong"
            return submitResponseObj;
        }

            return service;
        }

})();
